import { Request } from '@/classes/Request'

export const getFormDetailsUrl = async (submissionId: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    const req = new Request()
    req
      .post(`/ajax/form_details_url`, { form_submission_id: submissionId })
      .then(response => {
        resolve(response.data.url as string)
      })
      .catch(err => {
        reject('Failed to get form token: ' + err)
      })
  })
}
